import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchLikesSent } from "../../redux/actions/likeActions";
import ProjectCard from "../ProjectCard";
import PrestataireCardLike from "../PrestataireCardLike";

const LikesSentDashboard = ({ projetId = null }) => {
  const dispatch = useDispatch();
  const sentLikes = useSelector((state) => state.like.sent || []);
  const { user, token } = useSelector((state) => state.auth || {});

  const [currentIndex, setCurrentIndex] = useState(0);

  // Récupération des likes envoyés
  useEffect(() => {
    if (token) dispatch(fetchLikesSent(token));
  }, [dispatch, token]);

  // Filtrer selon projet
  const filteredLikes = projetId
    ? sentLikes.filter((like) => like?.projet?.idProjetClient === projetId)
    : sentLikes;

  // Ajuster l’index si la liste change
  useEffect(() => {
    if (currentIndex >= filteredLikes.length) {
      setCurrentIndex(0);
    }
  }, [filteredLikes, currentIndex]);

  const currentLike = filteredLikes[currentIndex] || {};
  const currentProject = currentLike?.projet;
  const currentPrestataire = currentLike?.prestataire?.profilPrestataire;

  const containerStyle = {
    //padding: "20px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    textAlign: "center",
    margin: "20px"
  };

  const navContainer = {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    width: "100%",
    maxWidth: "500px",
    marginTop: "15px",
  };

  const navButton = {
    padding: "8px 14px",
    borderRadius: "6px",
    border: "1px solid #ccc",
    cursor: "pointer",
    background: "#f7f7f7",
  };

  const disabledButton = {
    ...navButton,
    opacity: 0.4,
    cursor: "not-allowed",
  };

  return (
    <div style={containerStyle}>
      <h2>Demandes envoyées</h2>

      {filteredLikes.length === 0 || (!currentProject && !currentPrestataire) ? (
        <p>
          {projetId
            ? "Aucune demande envoyée pour ce projet 👀"
            : "Aucune demande envoyée pour le moment 👀"}
        </p>
      ) : (
        <>
          {/* --- CARTE --- */}
          {user?.rolesUser?.[0]?.roleUser === "prestataire" && currentProject ? (
            <ProjectCard
              project={currentProject}
              idUserClient={currentLike.client.idUser}
              onLike={null}
              onPass={null}
              isReceivedLike={false}
              isAlreadyMatched={true}
            />
          ) : (
            currentPrestataire && (
              <PrestataireCardLike
                prestataire={currentPrestataire}
                projet={currentProject}
                apiUrl={process.env.REACT_APP_API_URL}
                onLike={null}
                onPass={null}
                isReceivedLike={false}
                isAlreadyMatched={true}
              />
            )
          )}

          {/* --- NAVIGATION --- */}
          <div style={navContainer}>
            <button
              style={currentIndex === 0 ? disabledButton : navButton}
              disabled={currentIndex === 0}
              onClick={() => setCurrentIndex((prev) => prev - 1)}
            >
              ◀
            </button>

            <span>
              {currentIndex + 1} / {filteredLikes.length}
            </span>

            <button
              style={currentIndex === filteredLikes.length - 1 ? disabledButton : navButton}
              disabled={currentIndex === filteredLikes.length - 1}
              onClick={() => setCurrentIndex((prev) => prev + 1)}
            >
              ▶
            </button>
          </div>
        </>
      )}
    </div>
  );
};

export default LikesSentDashboard;
